import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-info-text',
  template: `
    <p>
      <ng-content></ng-content>
    </p>
    <button (click)="openHelp()" *ngIf="url" color="primary" mat-stroked-button>?</button>
  `,
  imports: [CommonModule, MatButton],
  styles: `
    :host {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin: 0 0 0.5em;
    }

    p {
      margin: 0 1em 0 0;
      flex-grow: 1;
    }

    button {
      margin-top: -5px;
      min-width: 1.2em;
      font-size: 16px;
      font-weight: bolder;
    }
  `
})
export class InfoTextBoxComponent {
  @Input() url?: string

  static openHelp(url: string) {
    const width = 1200;
    const height = 736;
    const screenLeft = window.screenLeft ?? window.screenX;
    const screenTop = window.screenTop ?? window.screenY;
    const screenWidth = window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;
    const screenHeight = window.innerHeight ?? document.documentElement.clientHeight ?? screen.height;

    const left = (screenWidth / 2) - (width / 2) + screenLeft;
    const top = (screenHeight / 2) - (height / 2) + screenTop;

    const newWindow = window.open(url,
      '_supplycanvas_wiki',
      `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=no,status=no,toolbar=no,menubar=no,location=no`);

    if (newWindow) {
      newWindow.focus();
      try {
        newWindow.resizeTo(width, height);
        newWindow.moveTo(left, top);
      } catch (_) {
      }
    } else {
      alert('Please allow popups for this website');
    }
  }

  openHelp() {
    InfoTextBoxComponent.openHelp(this.url!)
  }
}
